import React, {useEffect, useState} from 'react';
import {useMsal} from '@azure/msal-react';
import {Typography} from '@mui/material';
import {CONSTANT_AZURE_AUTHORIZED_GROUP} from '../../constants';
import {msalDefaultRequest} from '../../util/auth';
import {msalInstance} from '../../index';

export const LoggedInTemplate = ({children}) => {
  const {instance, inProgress} = useMsal();

  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const authorize = async () => {
      const response = await instance.acquireTokenSilent({
        ...msalDefaultRequest,
        account: instance.getActiveAccount() || instance.getAllAccounts()[0]
      });

      if (
        !response ||
        !response.idTokenClaims ||
        !response.idTokenClaims.groups
      ) {
        setIsAuthorized(false);
      } else {
        const isAuthorized = response.idTokenClaims.groups.includes(
          CONSTANT_AZURE_AUTHORIZED_GROUP
        );
        setIsAuthorized(isAuthorized);
        msalInstance.setActiveAccount(response.account);
      }
    };
    if (instance) authorize();
  }, [instance]);

  return inProgress || isAuthorized ? (
    children
  ) : (
    <Typography>Unauthorized.</Typography>
  );
};

export default LoggedInTemplate;
